import { render } from "./MenuIdioma.vue?vue&type=template&id=5b6a184c&scoped=true"
import script from "./MenuIdioma.vue?vue&type=script&lang=js"
export * from "./MenuIdioma.vue?vue&type=script&lang=js"

import "./MenuIdioma.vue?vue&type=style&index=0&id=5b6a184c&lang=css"
import "./MenuIdioma.vue?vue&type=style&index=1&id=5b6a184c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b6a184c"]])

export default __exports__